import axios from 'axios';
import React, { useState, useEffect } from 'react';
import '../assets/css/PollView.css';
import { baseurl } from '../utility/helper';
import { useNavigate, Link } from "react-router-dom";
import Swal from 'sweetalert2';

const Test = () => {
  const [chapters, setChapters] = useState([]);
  const roleid = parseInt(sessionStorage.getItem("userroleId"));
  const initialChapter = roleid === 2 ? sessionStorage.getItem("userchapterId") || "" : "";
  const [selectedChapter, setSelectedChapter] = useState(initialChapter);
  const navigate = useNavigate(); // Get navigate function
  const [privilege, setPrivilege] = useState(false);


  useEffect(() => {
    const fetchChapters = async () => {
      try {
        const response = await axios.get(`${baseurl}/admin/chapters`);
        setChapters(response.data); // Store API data in 'chapters'
      } catch (error) {
        console.error("Error fetching chapters:", error);
      }
    };

    fetchChapters();
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setMinDateTime(new Date().toISOString().slice(0, 16));
    }, 60000); // update every minute

    return () => clearInterval(timer);
  }, []);

  const [minDateTime, setMinDateTime] = useState(
    new Date().toISOString().slice(0, 16)
  );

  // SuperAdmin (roleid 1) may backdate tests and pick the SuperAdmin chapter.
  const isSuper = roleid === 1;
  const dtMin = (value) => (isSuper ? undefined : value);

  const [formData, setFormData] = useState({
    chapter: initialChapter || '',
    title: '',
    description: '',
    venue: '',
    startTime: '',
    endTime: '',
    regStartDateTime: '',
    regEndDateTime: '',
    // fees: '',
    ageGroup: '14.5-99',
    seat: '',
    note: '',
    isVisible: true
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    // If ageGroup is changed, reset the selected chapter
    if (name === "chapter") {
      setSelectedChapter(e.target.value);
      setFormData({ ...formData, [name]: value });
    } else {
      const { name, value } = e.target;
      setFormData({ ...formData, [name]: value });
    }
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    // Clean up form data to ensure no empty strings are sent for timestamps\

    console.log('Form Data:', formData);
    const cleanedFormData = {
      ...formData,
      privilege: formData.privilege ? 1 : 0,
      isVisible: formData.isVisible ? 1 : 0, 
      startTime: formData.startTime ? formData.startTime : null,
      endTime: formData.endTime ? formData.endTime : null,
      regStartDateTime: formData.regStartDateTime ? formData.regStartDateTime : null,
      regEndDateTime: formData.regEndDateTime ? formData.regEndDateTime : null,
      institute_test:0,
    };

    try {
      // Send a POST request to your API with formData
      const response = await axios.post(`${baseurl}/admin/tests`, cleanedFormData);

      // Handle successful response
      console.log('Form data successfully sent to the database:', response.data);
      // Show SweetAlert after successful submission
      Swal.fire({
        title: 'Success!',
        text: 'Test Details submitted successfully!',
        icon: 'success',
        timer: 5000, // Show for 5 seconds
        timerProgressBar: true,
        willClose: () => {
          setTimeout(() => {
            navigate("/admin/TestList"); // Navigate to MemberList page after 5 seconds
          }, 500);
        }
      });
      // Optionally, you can reset the form or navigate the user to another page
      setFormData({
        chapter: '',
        title: '',
        description: '',
        venue: '',
        startTime: '',
        endTime: '',
        regStartDateTime: '',
        regEndDateTime: '',
        note: '',
        // fees: '',
        ageGroup: '14.5-99',
        seat: '',
        isVisible: true
      });

    } catch (error) {
      // Handle error response
      console.error('Error sending form data to the database:', error);
    }
  };

  return (
    // <div className="page-wrapper">
    <div className="container mt-4">
    <button className="cl-back-btn " onClick={() => window.history.back()}>
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"><path d="M10 3L5 8l5 5"/></svg>
                        Back
                    </button>
      <form onSubmit={handleSubmit}>
        <div className="profile-section">
          <center><h3><b>Add Test</b></h3></center>
          <div className="col-md-12">
            <div className="row">
              <div className="col-md-6">
                <label htmlFor="chapter">Select Chapter:</label>
                <select
                  className="form-select"
                  id="chapter"
                  name="chapter"
                  value={selectedChapter}
                  onChange={handleChange}
                  disabled={roleid === 2} // Disable if roleid is 2
                  required
                >
                  <option value="" disabled>-- Select Chapter --</option>
                  {chapters.filter(term => isSuper || term.chapter_id !== 1) // Exclude chapter_id = 1 (except for SuperAdmin)
                  .map((term) => (
                    <option key={term.chapter_id} value={term.chapter_id}>
                      {term.chapter_name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-6">
                <label htmlFor="title">Test Title:</label>
                <input
                  type="text"
                  id="title"
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="col-md-6" style={{ paddingTop: '20px' }}>
                <label htmlFor="description">Test Description:</label>
                <textarea
                  id="description"
                  className="form-control"
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="col-md-6" style={{ paddingTop: '20px' }}>
                <label htmlFor="venue">Test Venue:</label>
                <input
                  type="text"
                  id="venue"
                  name="venue"
                  value={formData.venue}
                  onChange={handleChange}
                  required
                />
              </div>
             <div className="col-md-6" style={{ paddingTop: '20px' }}>
              <label htmlFor="regStartDateTime">Registration Start Datetime:</label>
              <input
                type="datetime-local"
                className="form-control"
                id="regStartDateTime"
                name="regStartDateTime"
                value={formData.regStartDateTime}
                onChange={handleChange}
                min={dtMin(minDateTime)}
                required
              />
            </div>

            <div className="col-md-6" style={{ paddingTop: '20px' }}>
              <label htmlFor="regEndDateTime">Registration End Datetime:</label>
              <input
                type="datetime-local"
                className="form-control"
                id="regEndDateTime"
                name="regEndDateTime"
                value={formData.regEndDateTime}
                onChange={handleChange}
                min={dtMin(formData.regStartDateTime || minDateTime)} // must be >= regStart
                required
              />
            </div>

            <div className="col-md-6" style={{ paddingTop: '20px' }}>
              <label htmlFor="startTime">Test Start Datetime:</label>
              <input
                type="datetime-local"
                className="form-control"
                id="startTime"
                name="startTime"
                value={formData.startTime}
                onChange={handleChange}
                min={dtMin(formData.regEndDateTime || minDateTime)} // must be >= regEnd
                disabled={!formData.regStartDateTime || !formData.regEndDateTime} // disable until reg selected
                required
              />
            </div>

            <div className="col-md-6" style={{ paddingTop: '20px' }}>
              <label htmlFor="endTime">Test End Datetime:</label>
              <input
                type="datetime-local"
                className="form-control"
                id="endTime"
                name="endTime"
                value={formData.endTime}
                onChange={handleChange}
                min={dtMin(formData.startTime || minDateTime)} // must be >= testStart
                disabled={!formData.startTime} // disable until test start selected
                required
              />
            </div>

              
              <div className="col-md-6" style={{ paddingTop: '20px' }}>
                <label htmlFor="ageGroup">Age Group:</label>
                <select
                  id="ageGroup"
                  name="ageGroup"
                  value={formData.ageGroup}
                  onChange={handleChange}
                  className="form-select"
                >
                  <option value="10-14.5">10 to 14.5 years</option>
                  <option value="14.5-99" >14.5 to 99 years</option>
                </select>
              </div>
              <div className="col-md-6" style={{ paddingTop: '20px' }}>
                <label htmlFor="seat">Seat Capacity:</label>
                <select
                  id="seat"
                  name="seat"
                  value={formData.seat}
                  className="form-select"
                  onChange={handleChange}

                >
                  {[...Array(35)].map((_, index) => (
                    <option key={index + 1} value={index + 1}> {index + 1} </option>
                  ))}
                </select>
              </div>
              <div className="col-md-12 mt-2" style={{ paddingTop: '10px' }}>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="privilege"
                    name="privilege"
                    checked={formData.privilege || false}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        privilege: e.target.checked,
                      })
                    }
                  />
                  <label className="form-check-label" htmlFor="privilege">
                    Under Privilege
                  </label>
                </div>
              </div>
              <div className="col-md-12 mt-2" style={{ paddingTop: '10px' }}>
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="isVisible"
                  name="isVisible"
                  checked={formData.isVisible || false}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      isVisible: e.target.checked,
                    })
                  }
                />
                <label className="form-check-label" htmlFor="isVisible">
                  {formData.isVisible ? "Visible" : "Invisible"}
                </label>
              </div>
            </div>
              <div className="col-md-12" style={{ paddingTop: '10px' }}>
                <label htmlFor="note">Note:</label>
                <textarea
                  id="note"
                  className="form-control"
                  name="note"
                  value={formData.note}
                  onChange={handleChange}
                />
              </div>
              <center style={{ paddingTop: '20px' }}>
                <Link to="/admin/TestList" style={{color:'white'}}><button className='btn btn-danger'>Cancel</button></Link>&nbsp;&nbsp;
                <button style={{ borderRadius: '8px' }} type="submit">Submit</button>
              </center>
            </div>
          </div>
        </div>
      </form>
    </div>
    // </div>
  );
};

export default Test;
